import { RestApiResponse } from '../../common/rest-api.response';
import { BaseField } from '../base-field';

export class TaxonomyBaseFieldUpdateResponse extends RestApiResponse {
    public field: BaseField;

    constructor(data?: Partial<TaxonomyBaseFieldUpdateResponse>) {
        super(data);
        this.field = data?.field;
    }
}
